import type { IMessageTemplate } from '@/types/Data'
import type { IDeleteMessageTemplate, IPayloadMessageTemplate } from '@/types/Request'
import BaseService from '../BaseService'

export default class MessageTemplateServices extends BaseService {
  GetMessageTemplateList() {
    return this.GET<IMessageTemplate[]>(this.PATHS.GET_MESSAGE_TEMPLATE_LIST, {
      Skip: null,
      Take: null,
    })
  }

  CreateMessageTemplate(payload: IPayloadMessageTemplate) {
    return this.POST<void>(this.PATHS.CREATE_MESSAGE_TEMPLATE, payload)
  }

  UpdateMessageTemplate(payload: IPayloadMessageTemplate) {
    return this.PUT<IMessageTemplate>(this.PATHS.UPDATE_MESSAGE_TEMPLATE, payload)
  }

  DeleteMessageTemplate(payload: IDeleteMessageTemplate) {
    return this.DELETE<void>(this.PATHS.DELETE_MESSAGE_TEMPLATE, payload)
  }
}
